/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import * as React from "react";
import CustomDataGrid from "../../Shared/Table/CustomDataGrid";
import { useFilesData } from "./hooks";
import { filesColumn } from "../../Shared/Table/Columns";
import { IFiles } from "../../../store/api/deviceConfig/types";
import { GridSortModel } from "@mui/x-data-grid";
import { getSortBy } from "../../../utils/helpers";
import FilesFilter from "../../Shared/Filter/FilesFilter";

const DebugLogs: React.FC = () => {
  const fileType: string = "debuglogs";
  const { rowData, noOfRows, isLoading, setSortOrderFile } = useFilesData(fileType);
  const columns = filesColumn(fileType);

  return (
    <div className="flex flex-col gap-1 mt-2">
      <FilesFilter />
      <span className="text-sm text-muted-foreground mt-3">{`Showing ${noOfRows} results`}</span>
      <CustomDataGrid
        tableId={fileType}
        rows={rowData}
        columns={columns}
        checkboxSelection={false}
        rowCount={noOfRows}
        loading={isLoading}
        disableColumnMenu={true}
        disableRowSelectionOnClick={true}
        getRowId={(row: IFiles) => row.objectKey}
        sx={{
          "& .MuiDataGrid-virtualScroller": { overflowY: "hidden" },
          "& .MuiDataGrid-scrollbar--vertical": { display: "none" },
        }}
        onSortModelChange={(params: GridSortModel) => setSortOrderFile(getSortBy(params))}
        fillContainer={false}
      />
    </div>
  );
};

export default DebugLogs;
